<div class="form-inputs">
    @if (searchByAwb) {
        <div>
            <app-sprintpay-awb-search
                (eventOnChangeLocation)="onChangeLocation($event)"
                (eventOnEnter)="onEnter($event)"
                (eventOnSearching)="isSearchingValue($event)"
            />
        </div>
    }
    @if (!searchByAwb) {
        <div>
            <app-flight-number-search (eventOnEnter)="onEnter($event)" (eventOnSearching)="isSearchingValue($event)" />
        </div>
    }
</div>

@if (enableSearchByFlightNumber) {
    <div class="d-flex justify-content-center">
        <button matButton="outlined" color="primary" (click)="changeBySearch()" class="mat-subtitle-2 border-0">
            <div class="d-flex align-items-center justify-content-center">
                @if (searchByAwb) {
                    <mat-icon color="primary" class="material-icons md-icon-18 me-2 overflow-visible">
                        calendar_month
                    </mat-icon>
                } @else {
                    <mat-icon color="primary" class="material-icons md-icon-18 me-2 overflow-visible">
                        search
                    </mat-icon>
                }
                SEARCH BY {{ searchByAwb ? 'FLIGHT NUMBER TO MAKE ADVANCE ISC PAYMENT' : 'AWB' }}
            </div>
        </button>
    </div>
}
